import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/lib/auth-context";
import { Button } from "@/components/ui/button";
import { Smartphone } from "lucide-react";
import logoImg from "@/assets/logo.webp";
import InstallInstructionsDialog from "./InstallInstructionsDialog";

export default function Footer() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [installOpen, setInstallOpen] = useState(false);

  const handleProtectedNav = (e: React.MouseEvent, to: string) => {
    if (user) return;
    e.preventDefault();
    navigate("/auth");
  };

  return (
    <footer className="mt-16 border-t border-border bg-foreground text-background">
      <div className="container max-w-6xl py-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {/* Brand */}
          <div className="space-y-4">
            <div className="inline-flex items-center rounded-lg bg-background px-3 py-2">
              <img src={logoImg} alt="LPU Football Shirts" className="h-10 w-auto object-contain" />
            </div>
            <p className="text-sm text-background/60 leading-relaxed">
              LPU Football Shirts, czyli portal dla kolekcjonerów koszulek piłkarskich
            </p>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <h3 className="text-xs font-bold uppercase tracking-widest text-background/40">Nawigacja</h3>
            <ul className="space-y-2.5">
              <li><Link to="/explore" onClick={(e) => handleProtectedNav(e, "/explore")} className="text-sm text-background/60 hover:text-primary transition-colors">Przeglądaj koszulki</Link></li>
              <li><Link to="/add-kit" onClick={(e) => handleProtectedNav(e, "/add-kit")} className="text-sm text-background/60 hover:text-primary transition-colors">Dodaj koszulkę</Link></li>
            </ul>
          </div>

          {/* Info */}
          <div className="space-y-4">
            <h3 className="text-xs font-bold uppercase tracking-widest text-background/40">Informacje</h3>
            <ul className="space-y-2.5">
              <li><Link to="/regulamin" className="text-sm text-background/60 hover:text-primary transition-colors">Regulamin</Link></li>
              <li><Link to="/polityka-prywatnosci" className="text-sm text-background/60 hover:text-primary transition-colors">Polityka prywatności</Link></li>
              <li><a href="mailto:jaacek.janczewski@gmail.com" className="text-sm text-background/60 hover:text-primary transition-colors">Kontakt</a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background/10 bg-foreground">
        <div className="container max-w-6xl flex flex-col items-center justify-between gap-3 py-4 text-xs text-background/40 sm:flex-row">
          <span>© 2026 LPUfootballshirts. Wszelkie prawa zastrzeżone.</span>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => setInstallOpen(true)}
            className="gap-2 border-background/30 bg-transparent text-background hover:bg-background hover:text-foreground"
          >
            <Smartphone className="h-4 w-4" />
            Zainstaluj LPU Football Shirts na telefonie
          </Button>
        </div>
      </div>

      <InstallInstructionsDialog open={installOpen} onOpenChange={setInstallOpen} />
    </footer>
  );
}
